import LangLink from "./LangLink";

// Refined wordmark logo (no clinical/surgical graphics per brand rules).
// A simple lotus-inspired line mark + editorial wordmark.
export default function Logo({ variant = "dark", className = "", withText = true, testId = "site-logo" }) {
  const markColor = variant === "light" ? "hsl(var(--background))" : "hsl(var(--primary))";
  const accent = "hsl(var(--accent))";
  const textColor = variant === "light" ? "text-background" : "text-primary";
  const subColor = variant === "light" ? "text-background/70" : "text-muted-foreground";

  return (
    <LangLink to="/" className={`inline-flex items-center gap-3 group ${className}`} data-testid={testId} aria-label="Plastic Surgery Vietnam — home">
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" aria-hidden="true" className="shrink-0 transition-transform duration-500 group-hover:rotate-[-6deg]">
        <path d="M20 4 C20 14, 14 20, 4 20 C14 20, 20 26, 20 36 C20 26, 26 20, 36 20 C26 20, 20 14, 20 4 Z" stroke={markColor} strokeWidth="1.25" fill="none" />
        <circle cx="20" cy="20" r="3" fill={accent} />
      </svg>
      {withText && (
        <span className="flex flex-col leading-none">
          <span className={`font-serif text-xl md:text-2xl font-medium tracking-tight ${textColor}`}>
            Plastic Surgery
          </span>
          <span className={`font-sans text-[10px] md:text-[11px] uppercase tracking-[0.38em] mt-1 ${subColor}`}>
            Vietnam
          </span>
        </span>
      )}
    </LangLink>
  );
}
